export default __webpack_public_path__ + "static/media/ser4.f825a138.svg";